import React, { useState, useCallback, useEffect } from 'react'
import { Box, Grid, FormControl, MenuItem, Select, Typography } from '@mui/material'
import UnitsMarkingActivity from './UnitsMarkingActivity'
import StudentsGrowthOverview from './StudentsGrowthOverview'
import { getClassesOverview } from '../../../../../../services/dashboard/dashboard.service'

const ClassesOverview = ({ userId, isLoadingMyClasses, myClasses = [] }) => {
  const [data, setData] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [selectedClass, setSelectedClass] = useState('all')
  const [classOptions, setClassOptions] = useState([
    {
      _id: 'all',
      code: 'All classes'
    }
  ])

  const onLoad = useCallback(async () => {
    try {
      setIsLoading(true)
      const response = await getClassesOverview(userId, selectedClass)

      if (response?.error || !response?.data) {
        return
      }
      setData(response?.data)
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }, [selectedClass])

  useEffect(() => {
    onLoad()
  }, [onLoad])

  useEffect(() => {
    const newoptions = [
      {
        _id: 'all',
        code: 'All classes'
      },
      ...myClasses
    ]
    setClassOptions(newoptions)
  }, [myClasses])

  return (
    <Box sx={{ borderRadius: 2, bgcolor: '#E2E5EA', mt: 2 }}>
      <Box sx={{ px: 2, marginTop: -2 }}>
        <Box
          className='sticky top-0x'
          sx={{
            position: 'sticky',
            top: 0,
            zIndex: 1,
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            backgroundColor: '#E2E5EA',
            borderRadius: 1,
            p: 1,
            maxWidth: '260px',
            ml: 'auto'
          }}
        >
          <FormControl variant='outlined' size='small' fullWidth>
            <Select
              value={selectedClass}
              onChange={(event) => setSelectedClass(event.target.value)}
              displayEmpty
              disabled={isLoadingMyClasses}
              sx={{
                backgroundColor: '#fff',
                borderRadius: '4px',
                '& .MuiSelect-select': {
                  py: 0.75,
                  px: 1.5
                }
              }}
            >
              {classOptions.map((option) => (
                <MenuItem key={option._id} value={option._id}>
                  {option.code}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>

      <Box sx={{ px: 2, pb: 2 }}>
        {/* <Typography variant='caption' sx={{ color: '#6b7280', display: 'block', mb: 1.5 }}>
          Showing overview for: {classOptions.find((option) => option._id === selectedClass)?.cpde}
        </Typography> */}
        <UnitsMarkingActivity
          unitsMarkingActivity={data?.unitsMarkingActivity || []}
          isLoading={isLoading}
          statuses={data?.statusData || []}
        />
        <div className='py-2'></div>
        <StudentsGrowthOverview
          students={data?.studentsGrowth || []}
          isLoading={isLoading}
          statuses={data?.statusStudent || []}
        />
      </Box>
    </Box>
  )
}

export default ClassesOverview
